import { Chip } from '@w7/ui'
import type { AgentMfaStatus } from './agentTypes'
import type { PlayerMfaUser } from './types'

/** Shared chip for member head + tables — distinguishes portal vs console vault. */
export function PlayerPortalMfaChip({
  status,
  loading,
}: {
  status: PlayerMfaUser | null | undefined
  loading?: boolean
}) {
  if (loading) {
    return (
      <Chip tone="muted" size="sm">
        Portal 2FA…
      </Chip>
    )
  }
  if (!status) {
    return (
      <Chip tone="muted" size="sm" title="No matching player portal account">
        Portal 2FA unknown
      </Chip>
    )
  }
  const methods = status.methods
    .map((m) => (m === 'totp' ? 'App' : 'SMS'))
    .join('+')
  return (
    <Chip
      tone={status.mfaEnabled ? 'profit' : 'muted'}
      size="sm"
      title={
        status.mfaEnabled
          ? `Player portal 2FA on (${status.methods
              .map((m) => (m === 'totp' ? 'Authenticator' : 'SMS'))
              .join(', ')})`
          : 'Player portal 2FA off'
      }
    >
      {status.mfaEnabled ? `Portal 2FA · ${methods}` : 'Portal 2FA off'}
    </Chip>
  )
}

export function ConsoleMfaChip({
  status,
  loading,
}: {
  status: AgentMfaStatus | null | undefined
  loading?: boolean
}) {
  if (loading) {
    return (
      <Chip tone="muted" size="sm">
        Console 2FA…
      </Chip>
    )
  }
  if (!status || !status.found) {
    return (
      <Chip tone="muted" size="sm" title="No Keycloak login found for this agent">
        Console 2FA unknown
      </Chip>
    )
  }
  const methods = status.methods
    .map((m) => (m === 'totp' ? 'App' : m === 'passkey' ? 'Passkey' : 'Recovery'))
    .join('+')
  return (
    <Chip
      tone={status.mfaEnabled ? 'profit' : 'muted'}
      size="sm"
      title={
        status.mfaEnabled
          ? `Agent console 2FA on (${status.methods.join(', ')})`
          : 'Agent console 2FA off'
      }
    >
      {status.mfaEnabled ? `Console 2FA · ${methods}` : 'Console 2FA off'}
    </Chip>
  )
}
